// extracted by mini-css-extract-plugin
export default {"container":"gT-z","confirmation":"hT-z","action":"iT-z","disabled":"jT-z","returnLabel":"kT-z","returnLabels":"lT-z","buttonOnly":"mT-z"};